import React from 'react';
import { useAppDispatch } from '../../../../../../redux/hooks';
import {
  setSignificanceFunnelStep,
  setSignificanceFunnelTimeToConvertMetric,
} from '../../../../../../redux/slices/oldBuilder';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';
import {
  FunnelTimeToConvertMetric,
  IFunnelModeSliceFieldsFragment,
  IFunnelStepBriefInfoFieldsFragment,
  IUserAliasReplacementFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../../utils/types';
import FunnelModeSliceMenu from '../../../../../../components/FunnelStepMenu/FunnelModeSliceMenu';
import FunnelTimeToConvertMetricSelect from './FunnelTimeToConvertMetricSelect';
import styled from 'styled-components';

interface IProps {
  convertedOnStep: number;
  selectedMetric: FunnelTimeToConvertMetric | null;
  modeSlices?: IFunnelModeSliceFieldsFragment[];
  steps: IFunnelStepBriefInfoFieldsFragment[];
  aliasReplacements: IUserAliasReplacementFieldsFragment[];
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
`;

const SignificanceFunnelTimeToConvertMetricStep = ({
  convertedOnStep,
  selectedMetric,
  modeSlices,
  steps,
  aliasReplacements,
}: IProps) => {
  const dispatch = useAppDispatch();

  const handleSelectStep = (newValue: string) => {
    assertCondition(!isNaN(Number(newValue)));
    dispatch(setSignificanceFunnelStep({ stepIndex: Number(newValue) }));
  };

  const handleSelectMetric = (newValue: string) => {
    dispatch(
      setSignificanceFunnelTimeToConvertMetric({
        ttcMetric: newValue as FunnelTimeToConvertMetric,
      }),
    );
  };

  return (
    <Container>
      <BuilderUI.BuilderFieldLabel>Time to Convert</BuilderUI.BuilderFieldLabel>
      <FunnelModeSliceMenu
        steps={steps}
        modeSlices={modeSlices || []}
        selectedStep={convertedOnStep.toString()}
        onChange={handleSelectStep}
        aliasReplacements={aliasReplacements}
      />
      <FunnelTimeToConvertMetricSelect
        selectedMetric={selectedMetric}
        onChange={handleSelectMetric}
      />
    </Container>
  );
};

export default SignificanceFunnelTimeToConvertMetricStep;
